import React, { useCallback, useEffect } from 'react';

import { sendSmsOtp } from 'features/authentication/actions';
import {
  PhoneFormStep,
  ROOT_PATH,
} from 'features/authentication/SignIn/constants';
import { ErrorTrackingProps } from 'features/authentication/SignIn/types';

import CodeForm from '../CodeForm';

type Props = {
  phoneNumber: string;
  phoneId: string;
  onSetStep: (step: PhoneFormStep) => void;
  onSetPhoneId: (phoneId: string) => void;
  onSuccess: () => void;
} & ErrorTrackingProps;

const PhoneCodeForm = ({
  phoneNumber,
  phoneId,
  onSetStep,
  onSetPhoneId,
  onError,
  onSuccess,
}: Props) => {
  const handleBackClick = useCallback(
    () => onSetStep(PhoneFormStep.PHONE),
    [onSetStep]
  );

  const handleSuccess = useCallback(() => {
    onSuccess();
    window.location.href = ROOT_PATH;
  }, [onSuccess]);

  const handleSmsResend = useCallback(
    () => sendSmsOtp({ phone: phoneNumber }),
    [phoneNumber]
  );

  useEffect(() => {
    // phoneId (set in Phone view) needed to authenticate OTP in Code view
    // Edge case if we link directly to this code form view
    if (!phoneId || !phoneNumber) onSetStep(PhoneFormStep.PHONE);
  }, [onSetStep, phoneId, phoneNumber]);

  return (
    <CodeForm
      phoneNumber={phoneNumber}
      methodId={phoneId}
      onBackClick={handleBackClick}
      onSetMethodId={onSetPhoneId}
      onSuccess={handleSuccess}
      onResendCode={handleSmsResend}
      onError={onError}
    />
  );
};

export default PhoneCodeForm;
